import { render, staticRenderFns } from "./BiodiversityInventory.vue?vue&type=template&id=ef19e1ce"
import script from "./BiodiversityInventory.vue?vue&type=script&lang=js"
export * from "./BiodiversityInventory.vue?vue&type=script&lang=js"
import style0 from "./BiodiversityInventory.vue?vue&type=style&index=0&id=ef19e1ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports